import React from 'react';
import styled from 'styled-components';

import { Box } from 'Components/Base';

const ActionButtonContainer = styled((props) => <Box {...props} />)`
  flex-shrink: 0;
  margin: 1rem 0;
  width: 100%;
`;

export default ActionButtonContainer;
